/**
 * The add-a-source form's fields: platform, URL and the optional external
 * identity.
 */

import { useState } from 'react';

export type SourceForm = ReturnType<typeof useSourceForm>;

export function useSourceForm() {
  const [newPlatform, setNewPlatform] = useState('WEBSITE');
  const [newUrl, setNewUrl] = useState('');
  const [newIdentity, setNewIdentity] = useState('');

  return {
    newPlatform,
    setNewPlatform,
    newUrl,
    setNewUrl,
    newIdentity,
    setNewIdentity,
  };
}
